// file: src/KalkulatorDoprinosiKomercijalno4537.js

import React, { useState, useEffect } from 'react';
import './Kalkulator.css';
import { FaIndustry } from 'react-icons/fa'; // simbolično za "komercijalno"

function KalkulatorDoprinosiKomercijalno4537() {
  // Godine koje podržavamo (iste kao u backendu)
  const godine = [2026, 2025, 2024, 2023, 2022, 2021, 2020, 2019, 2018];

  const [godina, setGodina] = useState(2025);
  const [rezultati, setRezultati] = useState(null);
  const [loading, setLoading] = useState(false);
  const [submitError, setSubmitError] = useState(null);

  useEffect(() => {
    const fetchData = async () => {
      setLoading(true);
      setRezultati(null);
      setSubmitError(null);

      try {
        const res = await fetch('https://plata--kalkulator-backend-api--gklzkvjpw2s5.code.run/doprinosi-komercijalno-45-37/', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ godina: godina })
        });
        if (!res.ok) {
          const errData = await res.json();
          throw new Error(errData.detail || 'Greška pri dohvaćanju.');
        }
        const data = await res.json();
        setRezultati(data);
      } catch (err) {
        setSubmitError(err.message);
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, [godina]);

  const handleChange = (e) => {
    setGodina(parseInt(e.target.value, 10));
  };

  return (
    <>
      {/* Naslov aplikacije */}
      <header className="app-header">
        <h1>
          KOMERCIJALNO GAZDINSTVO 45/37 <br />
          <br />
          (Osiguranici na PIO)
        </h1>
      </header>

    <div className="container">
      {/* Lijeva kartica: izbor godine */}
      <div className="form-container card">
        <div className="form-header">
          <h2>
            Odabir podataka
          </h2>
        </div>

        <div className="field-group">
          <label htmlFor="godina" className="field-label">
            Izaberite godinu<span className="required">*</span>:
          </label>
          <select
            id="godina"
            className="field-select"
            value={godina}
            onChange={handleChange}
          >
            {godine.map((g) => (
              <option key={g} value={g}>
                {g}
              </option>
            ))}
          </select>
        </div>
      </div>

      {/* Desna kartica: prikaz rezultata */}
      <div className="results-container card">
        {loading && <div className="section-title">Računam…</div>}
        {submitError && <div className="error-text">{submitError}</div>}
        {rezultati && (
          <>
            <h3 className="section-title">Rezultati za {godina}</h3>
            <div className="results-section">
              <div className="result-row">
                <span>Prosječna bruto plata:</span>
                <span>{rezultati.prosjecna_bruto.toFixed(2)}</span>
              </div>
              <div className="result-row">
                <span>Osnovica (30%):</span>
                <span>{rezultati.osnovica.toFixed(2)}</span>
              </div>
              <div className="result-row">
                <span>PIO:</span>
                <span>{rezultati.PIO.toFixed(2)}</span>
              </div>
              <div className="result-row">
                <span>
                  Zdravstveni doprinos (
                  {godina > 2021 ? '10.2%' : '12%'}):
                </span>
                <span>{rezultati.zdravstveno.toFixed(2)}</span>
              </div>
              <div className="result-row">
                <span>Ukupni troškovi za godinu dana:</span>
                <span>{rezultati.ukupni_troskovi.toFixed(2)}</span>
              </div>
            </div>
          </>
        )}
      </div>
    </div>
    </>
  );
}

export default KalkulatorDoprinosiKomercijalno4537;
